import React from 'react';
import PropTypes from 'prop-types';
import {Icon, Popup} from 'semantic-ui-react';

import {OutputTunnelPopupTable} from '@modules/events/components/OutputTunnelPopupTable';
import {VIDEO_MANAGEMENT_PLATFORM_LINK} from '@constants/variables';

const renderTunnelName = (row) => {
    const vtdId = row.third_party_client_tunnel_vtd_tunnel_id;

    if (!vtdId) {
        return <span>{row.third_party_client_tunnel_name}</span>;
    }

    return (
        <a
            href={`${VIDEO_MANAGEMENT_PLATFORM_LINK}/tunneler3/tunnel/${vtdId}`}
            target='_blank'
            rel='noopener noreferrer'
        >
            {row.third_party_client_tunnel_name}
        </a>
    );
};

const isTunnelStarted = (row) => {
    if ('boolean' === typeof row.vtd_tunnel_started) {
        return row.vtd_tunnel_started;
    }

    return 'started' === String(row.vtd_tunnel_status ?? '').trim().toLowerCase();
};

export const ArgosTunnelCell = ({row}) => {
    const isStarted = isTunnelStarted(row);
    const vtdId = row.third_party_client_tunnel_vtd_tunnel_id;
    const vtdName = row.vtd_tunnel_name ?? row.third_party_client_tunnel_name;

    return (
        <span className='argos-tunnel-cell'>
            <Popup
                className='--noPadding'
                trigger={<span>{renderTunnelName(row)}</span>}
                content={
                    <OutputTunnelPopupTable
                        vtdTunnelName={vtdName}
                        vtdTunnelId={vtdId}
                        isStarted={isStarted}
                        clientId={row.third_party_client_tunnel_client_id}
                        clientName={row.third_party_client_tunnel_client_name}
                        thirdPartyClientTunnelId={row.third_party_client_tunnel_id}
                    />
                }
                flowing
                hoverable
            />
            {!isStarted && (
                <Popup
                    trigger={
                        <Icon
                            name='warning sign'
                            color='red'
                            fitted
                            className='argos-tunnel-cell__warning'
                        />
                    }
                    content='The tunnel is not started!'
                    on='hover'
                />
            )}
        </span>
    );
};

ArgosTunnelCell.propTypes = {
    row: PropTypes.object.isRequired,
};
